import { jsx, jsxs } from 'react/jsx-runtime';
import { Flex, themedColor, font, useBodyScrollLock, useDialogContext } from '@lemonade-hq/cdk';
import { useRef, useCallback } from 'react';
import styled from 'styled-components';
import { DeleteIcon } from '../Icons/Icons.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  justify-content: center;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  justify-content: center;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Container = styled(Flex)(_templateObject(), themedColor("night"));
var DialogCloseIcon = styled(DeleteIcon)(_templateObject1());
var InternalDialogBody = styled(Flex)(_templateObject2(), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
    fontWeight: 700
}));
var DialogBody = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var ref = useRef(null);
    useBodyScrollLock({
        element: ref.current
    });
    return /*#__PURE__*/ jsx(InternalDialogBody, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        children: children
    }));
};
var DialogHeader = styled(Flex)(_templateObject3(), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
    fontWeight: 700
}));
var DialogFooter = styled(Flex)(_templateObject4());
var BaseDialog = function(_param) {
    var children = _param.children, onClose = _param.onClose, props = _object_without_properties(_param, [
        "children",
        "onClose"
    ]);
    var closeDialog = useDialogContext().closeDialog;
    var handleCloseClicked = useCallback(function() {
        closeDialog();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose,
        closeDialog
    ]);
    return /*#__PURE__*/ jsxs(Container, _object_spread_props(_object_spread({
        px: [
            "20px",
            "32px"
        ],
        py: [
            "20px",
            "32px"
        ]
    }, props), {
        children: [
            /*#__PURE__*/ jsx(DialogCloseIcon, {
                "aria-label": "close",
                "aria-roledescription": "close",
                onClick: handleCloseClicked,
                role: "button"
            }),
            children
        ]
    }));
};

export { BaseDialog, DialogBody, DialogCloseIcon, DialogFooter, DialogHeader };
